import { Component, InjectionToken, Injector, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { FormControlList } from './../modules/shared/constants/formcontrol-list.constants';

// PrimeNg
import { ConfirmationService, LazyLoadEvent, MenuItem, MessageService } from 'primeng/api';

// Components
import { AppMainComponent } from '../app.main.component';

// Models
import { ColumnSetting } from './models/configuration/columnSetting.model';
import { Field } from './models/configuration/field.model';
import { Stage } from './models/configuration/stage.model';
import { ContextMenuItem } from './models/contextMenuItem.model';
import { CustomField } from './models/fields/customField.model';
import { GridState } from './models/gridState.model';

// Services
import { AccountsHttpService } from 'src/app/modules/shared/services/accounts.http.service';
import { StoreService } from 'src/app/modules/shared/services/store.service';
import { AccountService } from '../accounts/accountService';
import { AppMainService } from '../app-main.service';
import { QuestionnaireService } from '../more/questionnaire/questionnaire.service';
import { PermissionService } from '../service/permission.service';
import { AccountHelper } from './services/accounts.helper';

// Constants and Enums
import { AccountModuleId } from 'src/app/modules/shared/constants/modules.constant';
import { ObjectNames } from '../shared/constants';
import { AccountViewTabIndex, Status } from './accounts.enum';

// Helpers
import { generateContactName } from '../modules/shared/helpers/generate-contact-name.helper';
import { ChannelN } from '../modules/shared/models/channel.model';
import { ColumnSettingsN, Fields, SectionN } from '../modules/shared/models/column-settings.model';
import { SharedChannelService } from '../modules/shared/services/channel.service';
import { SharedColumnSettingsService } from '../modules/shared/services/column-settings.service';
import { TimeZoneService } from '../modules/shared/services/timezone.service';
import { AccountUserService } from '../service/account.service';
import { FilterInColumn, GelAllAccountRequestModel, GetAllAccountsGroupByRequest, SavedFilterData } from './models/account-request.model';
import { StageN } from './models/stage.model';
import { AccountServiceN } from './services/account.services';
import { ParseHelper } from '../modules/shared/parse.helper';
import { filterDateRangeHelper } from '../modules/shared/helpers/filter-date-range.helper';
import { ConfigDefaultService } from '../modules/shared/services/configuration-default.service';
import { SharedContactsV1Component } from '../modules/shared/components/shared-contacts-v1/shared-contacts-v1.component';
import { ModuleWidgetService } from 'src/app/modules/shared/services/dynamic-table/module-widget.service';
import { DynamicTableChildWidgetM, DynamicTableModuleWidgetM } from '../modules/shared/models/dynamic-table/dynamic-table-module-widget.model';


export const ASSOCIATION_TYPE_NAME_ACCOUNT = new InjectionToken<string>('associationTypeName');
@Component({
    selector: 'app-accounts',
    templateUrl: './accounts.component.html',
    styleUrls: ['./accounts.component.scss'],
    providers: []
})

export class AccountsComponent implements OnInit, OnDestroy {
    showSharedContacts = false;
    accountTempAddress: any[];
    primaryContact: any;
    //Move Account
    displayAccountMoveDialog: boolean = false;
    selectedAccountForMove: any;
    currentSelectedChannelId: any;
    businessClassificationForCopy: any = {};
    allStagesForMove: any;

    /* Screen */
    isDetailsShowing: boolean = false;
    selectedView: string;
    isMenuShow = true;
    isLeftTableHide: boolean = false;

    /* Permission */
    readPermission: boolean;
    writePermission: boolean;
    editPermission: boolean;
    deletePermission: boolean;
    exportPermission: boolean;
    readContactPermission: boolean;

    stages: Stage[] = [];
    selectedActiveStages: Stage[] = []; //no effect

    contactDetails: Field[] = [];
    accountDetails: Field[] = [];

    accountObjId: number;

    accountInfoCustom: CustomField[] = [];

    /* Column Settings */
    columnSettings: ColumnSetting[] = [];
    savedStepbar: boolean;
    savedDefaultView: string;
    isActive: boolean = true;
    columnSettingName = ObjectNames.ACCOUNT_COLUMN_SETTINGS;

    savedListCols: Fields[] = [];
    savedListColsVM: Fields[] = [];
    listColsAll: Fields[] = [];
    enabledListCols: Fields[] = [];
    accountCols: Fields[] = [];
    savedDetailViewCols: Fields[] = [];
    detailBlocks: Fields[] = [];
    getPageListCalling: boolean = false;
    accountListCols = [
        {
            columnName: 'businessName',
            name: 'Account Name',
            enabled: true,
            value: ''
        }
    ];

    /* Listing */
    selectedAccount: any;
    filteredAccount: any;
    accountList: Array<any> = [];
    rowGroupMetadata: Array<any> = [];
    expandedRows: any = [];
    noAccountFindOrLoadingText = 'Loading....';
    pageNumber: number = 1;
    pageSize: number = 15;
    first: number = 0;
    totalRecords: number = 0;
    isFirst: boolean = false;
    tableShowMore: number[] = [15, 30, 50, 100];

    gridState: GridState = new GridState();
    searchValue: string = "";
    searchControl = new FormControl();
    fromGlobalSearch: boolean = false;
    globalSearchRefresh: boolean = false;
    globalSearchData: any[] = [];
    selectedStage: StageN;
    selectedStageId: number;
    hasChildAccounts: boolean;

    /* Account Add/Edit/View */
    selectedAccountId: number = 0;
    displayAddView: boolean = false;
    displayEditViewDialog: boolean = false;
    displayView: boolean = false;
    isAdd: boolean = false;
    isEdit: boolean = false;

    /* Account Active/Inactive */
    displayActiveInactiveModal: boolean = false;
    id: number;
    statusId: number;
    moduleName: string;
    activeInactiveFormType: string;

    /* Subject to unsubscribe */
    private ngUnsubscribe = new Subject<void>();

    /* Menu Data */
    menuItems: MenuItem[] = [];

    displaySettings: boolean = false;

    recentItems: { name: string; code: string }[] = [
        { name: "All Accounts", code: null },
        { name: 'My Accounts', code: 'my_accounts' },
        { name: 'New This week', code: 'new_this_week' },
        { name: 'New Last week', code: 'new_last_week' },
        { name: 'New This month', code: 'new_this_month' },
        { name: 'Recently Viewed Accounts', code: 'recently_viewed' }
    ];
    selectedRecent = { name: "All Accounts", code: null };

    /* Context Menu */
    contextMenuItems: ContextMenuItem[] = [];

    /* Account Details */
    selectedTabIndex = AccountViewTabIndex.OVERVIEW;
    accountViewTabIndex = AccountViewTabIndex;
    selectedAccountFromTable: number;
    objectId = 0;
    objectTypeId = 0;
    selectedStep: number;
    accountContacts: any[] = [];
    displayAccountDetails: boolean;
    addUpdateDone: boolean = false;
    accountData: any;

    /* Contact Tab on Account details */
    contactList = [];
    contactListAttn = [];
    selectedContact: any;
    noContactFindOrLoadingText: string;

    /* Check-In and Questionnaire Modals */
    displayCheckInPopup: boolean = false;
    displayQuestionnairePopup: boolean = false;
    questionnaires: any[] = [];
    visits: any[] = [];

    /* Import Accounts */
    displayImport: boolean = false;

    /* Export Accounts */
    displayExport: boolean = false;
    allListColumns: SectionN[] = [];

    selectedColumn: string[] = [];
    filterInColumns: FilterInColumn[] = [];
    sortByColumnName: string;
    isSortByDescending: boolean;

    // accountListingComponent: AccountsListingComponent;

    // @ViewChild(AccountsListingComponent) accountsTable: Table | undefined;

    fromUpdateSettings: boolean = false;

    //Copy Account
    displayCopyAccountDialog: boolean = false;
    isCopyAccount: boolean = false;
    currentSelectedAccountChannelIdForCopy: any;
    channelObjForCopy: any;

    //Account Group By
    selectedGroupByValue: any = null;
    selectedGroupBy: any = null;

    channelsN: ChannelN[] = []; // Will Change
    selectedChannelN: ChannelN;
    stagesCountN: StageN[] = [];
    savedStepbarN: boolean;
    columnSettingsN: Partial<ColumnSettingsN> = {};
    displayColumnSettings: boolean = false;
    savedListColsN: Fields[] = [];
    accountListN: any = [];
    appliedFilterColName: string[] = [];
    disabledLabelNames: string[] = [];

    //Account Mass Edit
    displayMassEdit = false;

    //Filter save data
    saveFilterData: SavedFilterData;

    //hide channel dropdown
    hideChannelDropdown: boolean = false;
    accountTreeViewEnabled: boolean = true;
    showFloatHeader: boolean = false;
    accountContactShared: typeof SharedContactsV1Component;
    accountContactInjector: Injector;
    associationTypeName: string = '';

    //sidebtn
    isShowSideBtn: boolean = true;
    showActionColumn: boolean = true;

    // workbook as Submodules related properties
    subModuleWidgets: DynamicTableChildWidgetM[] = [];
    selectedSubModule:DynamicTableChildWidgetM | null = null;
    showSubModuleWidgets: boolean = false;

    activeNavigation = {
        module: true,  // true = module is active, false = workbook is active
        subModuleId: null as number | null,
        contacts: false  // true = contacts view is active, false = module/workbook view is active
    };

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        public app: AppMainComponent,
        private accountsHttpService: AccountsHttpService,
        private accountService: AccountService,
        public appMainService: AppMainService,
        private questionnaireService: QuestionnaireService,
        private permissionService: PermissionService,
        private storeService: StoreService,
        private accountHelper: AccountHelper,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        private sharedChannelService: SharedChannelService,
        private accountServiceN: AccountServiceN,
        private sharedColumnSettingsService: SharedColumnSettingsService,
        private userService: AccountUserService,
        private timeZoneService: TimeZoneService,
        private configDefaultService: ConfigDefaultService,
        private moduleWidgetService: ModuleWidgetService
    ) {
    }

    async ngOnInit(): Promise<void> {
        // Initial load of subModuleWidgets
        this.loadSubModuleWidgets();
        // Subscribe to workbook changes to auto-update subModuleWidgets when changes occur
        this.moduleWidgetService.getModuleWidgets()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((moduleWidgets: DynamicTableModuleWidgetM[]) => {
                this.loadSubModuleWidgets();
            });
        this.getDefaultSettings();
        this.checkChannelPermission();
        this.setPermissions();
        this.searchAccounts();
        this.getAccountDetailsByStore();
        this.getContactListByStore();
        this.getChannels();
    }

    async getDefaultSettings(){
        const accountTreeView = await this.configDefaultService.getAccountTreeViewSettings();
        this.accountTreeViewEnabled = !accountTreeView || (accountTreeView && accountTreeView?.enabled);
    }

    // Set permissions for read, write, edit, delete and export
    setPermissions(): void {
        const userPermissions = this.permissionService.getPermissionData();

        if (userPermissions.length) {
            let accountPermission = userPermissions.find(obj => obj.objectName === ObjectNames.ACCOUNT);
            let contactPermission = userPermissions.find(obj => obj.objectName === ObjectNames.CONTACT);
            let importExportPermission = userPermissions.find(obj => obj.objectName === ObjectNames.Import_Export);
            importExportPermission = importExportPermission?.permissions?.sort((a, b) => (a.permissionId < b.permissionId) ? -1 : 1) ?? [];
            accountPermission = accountPermission.permissions.sort((a, b) => (a.permissionId < b.permissionId) ? - 1 : 1);
            contactPermission = contactPermission.permissions.sort((a, b) => (a.permissionId < b.permissionId) ? - 1 : 1);
            this.readPermission = accountPermission && (accountPermission[0].permissionId == 1 && accountPermission[0].statusId == 1);
            this.writePermission = accountPermission && (accountPermission[1].permissionId == 2 && accountPermission[1].statusId == 1);
            this.editPermission = accountPermission && (accountPermission[2].permissionId == 3 && accountPermission[2].statusId == 1);
            this.deletePermission = accountPermission && (accountPermission[3].permissionId == 4 && accountPermission[3].statusId == 1);
            this.exportPermission = importExportPermission?.[4]?.permissionId === 5 && importExportPermission?.[4]?.statusId === 1;
            this.readContactPermission = contactPermission && (contactPermission[0].permissionId == 1 && contactPermission[0].statusId == 1);
        }
    }

    async checkChannelPermission(){
        const channelPermissionsCount = await this.permissionService.getChannelPermissionsCount();
        this.hideChannelDropdown = !!(channelPermissionsCount?.allowedLicence && channelPermissionsCount?.allowedLicence==1);
    }

    // Fired when user start typing on search bar
    searchAccounts() {
        this.searchControl.valueChanges.pipe(
            debounceTime(700),
            distinctUntilChanged())
            .subscribe((value: string) => {
                this.searchValue = value.trim() || '';
                this.loadListingWithFilters();
            });
    }

    // Get Context Menu Options
    getContextMenuOptions(selectedAccount) {
        this.selectedAccount = selectedAccount;
        this.contextMenuItems = [];

        const status = selectedAccount.statusId == Status.Active ? 'Inactive' : 'Active';

        if (this.readPermission) {
            this.contextMenuItems.push({
                label: 'View',
                icon: 'pi pi-list',
                command: async () => {
                    this.showEditAccount(selectedAccount.id, true);
                }
            });
        }

        if (this.editPermission && selectedAccount.statusId == Status.Active) {
            this.contextMenuItems.push({
                label: 'Edit',
                icon: 'pi pi-pencil',
                command: async () => {
                    this.showEditAccount(selectedAccount.id);
                }
            });

            this.contextMenuItems.push({
                label: 'Check In',
                icon: 'pi pi-map-marker',
                command: () => {
                    this.showCheckInPopup();
                }
            });
        }

        if (this.deletePermission && selectedAccount.statusId == Status.Active) {
            this.contextMenuItems.push({
                label: 'Delete',
                icon: 'pi pi-trash',
                command: () => {
                    this.onDeleteAccount(selectedAccount);
                }
            });
        }

        if (this.editPermission) {
            this.contextMenuItems.push({
                label: status + ' Account',
                icon: 'pi pi-pencil',
                command: async () => {
                    this.onActiveInactiveAccount(selectedAccount);
                }
            });
        }
        if (this.editPermission && selectedAccount.statusId == Status.Active && !selectedAccount?.mainCustomerId) {
            this.contextMenuItems.push({
                label: 'Move Account',
                icon: 'pi pi-forward',
                command: async () => {
                    this.onMoveAccount(selectedAccount);
                    this.currentSelectedChannelId = this.selectedChannelN.id;
                }
            });
        }

        if (this.editPermission && selectedAccount.statusId == Status.Active) {
            this.contextMenuItems.push({
                label: 'Make Copy',
                icon: 'pi pi-copy',
                command: async () => {
                    await this.getAccountDetailsById(selectedAccount.id)
                    this.isCopyAccount = true;
                    this.onCopyAccount();
                }
            });
        }
    }

    onCopyAccount(): void {
        this.displayCopyAccountDialog = true;
    }

    cancelCopyAccountModal() {
        this.displayCopyAccountDialog = false;
    }

    openAddForCopy() {
        this.openAddAccountForCopy();

    }

    selectedAccountChannelIdForCopy(channel: any) {
        this.displayCopyAccountDialog = false;
        this.channelObjForCopy = channel.accountChannel;
        this.currentSelectedAccountChannelIdForCopy = channel.accountChannel.id;
        this.businessClassificationForCopy = channel.businessClassification
        this.stagesCountN = channel.stagesForCopy;
    }

    async showEditAccount(accountId: number, isView: boolean = false) {
        this.displayEditViewDialog = true;
        this.displayView = isView;
        this.isAdd = false;
        this.isEdit = true;
        this.selectedAccountId = accountId;
    }

    toggleAccountContacts() {
        this.associationTypeName = 'account';
        this.showSharedContacts = !this.showSharedContacts;
        if (this.showSharedContacts) {
            this.showSubModuleWidgets = false;
            this.selectedSubModule = null;
            this.activeNavigation.contacts = true;
            this.activeNavigation.module = false;
            this.activeNavigation.subModuleId = null;
            // this.isMenuShow = true;
        } else {
            this.activeNavigation.contacts = false;
            this.activeNavigation.module = true;
        }
    }

    navigateToAccount() {
        this.showSharedContacts = false;
        this.showSubModuleWidgets = false;
        this.selectedSubModule = null;
        this.activeNavigation.module = true;
        this.activeNavigation.subModuleId = null;
        this.activeNavigation.contacts = false;
        this.selectedTabIndex = 0;
    }

    showCheckInPopup(): void {
        this.displayCheckInPopup = true;
    }

    loadQuestionnaireQuestions(): void {
        this.displayCheckInPopup = false;

        const data = {
            "visitId": 0, // 0 for new
            "organizationId": this.app.user.organizationId,
            "objectTypeId": this.app.preLoadedObjects.find(obj => obj.name == ObjectNames.ACCOUNT).id, // 1 -lead, 2 -account
            "objectRecordId": this.selectedAccount.id, // leadid. accountid
            "userId": this.app.user.userId,
            "visitTypeId": 16, // 16 for office phone, for others get from above api
            "storeLatitude": 0,
            "storeLongitude": 0,
            "checkInAddress": "", // lead address
            "checkOutAddress": "", //lead address
            "latitude": 0,  // will be 0 only for office phone
            "longitude": 0, // will be 0 only for office phone
            "isUpdateAddress": false, // false alway for now
            "startDateTime": new Date().toISOString(), // timer on time
            "endDateTime": new Date().toISOString() // // timer on time
        };

        this.appMainService.isShowSpinner('CreateVisit');

        this.questionnaireService.createVisit(data)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
                resp => {
                    this.app.getAllObjects();
                    this.displayQuestionnairePopup = true;
                    this.questionnaires = resp;
                    this.visits = resp.visit;
                    this.appMainService.isHideSpinner('CreateVisit');
                }, () => {
                    this.appMainService.isHideSpinner('CreateVisit');
                }
            );
    }

    onCheckoutQuestionnaire() {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Questionnaire submitted successfully...' });
        this.displayQuestionnairePopup = false;
    }

    onCancelQuestionnaire() {
        this.displayQuestionnairePopup = false;
    }

    onDeleteAccount(selectedAccount: any) {
        if (selectedAccount.hasChildAccounts && selectedAccount.statusId === 1) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Parent has child, can not be deleted ...'
            });
            return;
        }

        const { id } = selectedAccount;

        if (!id) {
            return;
        }

        this.confirmationService.confirm({
            message: 'Do you want to delete this Account?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.appMainService.isShowSpinner('deleteAccount');
                this.accountService.deleteAccount(id)
                    .then(() => {
                        this.isFirst = true;
                        this.refreshListing();

                        if (this.selectedView == 'split') {
                            this.selectedView = 'list';
                            this.accountCols = this.listColsAll;
                            this.savedListCols = this.listColsAll;
                        }

                        this.messageService.add({
                            severity: 'success',
                            summary: 'Success',
                            detail: 'Account Deleted Sucessfully...'
                        });

                        this.appMainService.isHideSpinner('deleteAccount');
                    }).catch((err) => {
                        if (err.status != 422) {
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Error',
                                detail: 'Error occurred while deleting Account...'
                            });
                        }

                        this.appMainService.isHideSpinner('deleteAccount');
                    });
            }
        });
    }

    onActiveInactiveAccount(selectedAccount: any): void {
        if (selectedAccount.hasChildAccounts && selectedAccount.statusId === 1) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Parent has child, can not be made in-active ...'
            });
            return;
        }

        this.displayActiveInactiveModal = true;
        this.id = selectedAccount.id;
        this.statusId = selectedAccount.statusId;
        this.moduleName = 'Account';
        this.activeInactiveFormType = 'Add';
    }

    saveActiveInactiveModal() {
        this.cancelActiveInactiveModal();
        this.loadListingWithFilters();
    }

    cancelActiveInactiveModal() {
        this.displayActiveInactiveModal = false;
        this.id = null;
        this.statusId = null;
        this.activeInactiveFormType = '';
    }
    onMoveAccount(selectedAccount: any): void {
        this.selectedAccountForMove = selectedAccount;
        this.displayAccountMoveDialog = true;
    }
    cancelMoveAccountModal() {
        this.displayAccountMoveDialog = false;
    }
    saveMoveAccountModal(channel) {
        this.selectedChannelN = channel;
        this.displayAccountMoveDialog = false;
        this.changeChannel();
    }

    buildMenuBar(view, i): void {
        let listlab = (this.savedDefaultView == "list") ? 'List View <i title="Default View" class="pi pi-eye menuDefault"></i>'
            : 'List View';

        let items: { label: string; escape?: boolean; icon: string; command: () => void }[] = [];

        this.menuItems = [];

        if (this.writePermission) {
            // this.menuItems.push({
            //     label: 'New',
            //     icon: 'pi pi-plus',
            //     command: () => this.openAddAccount(),
            // });

            items.push({
                label: 'New',
                icon: 'pi pi-plus',
                command: () => this.openAddAccount(),
            });

            items.push({
                label:'Mass Edit',
                icon:'fa fa-pencil-square-o',
                command: () => {
                    this.openMassEdit();
                }
            });
        }

        if (this.exportPermission) {
            items.push(
                {
                    label: 'Import',
                    icon: 'pi pi-download',
                    command: () => this.openImportAccounts(),
                },
                {
                label: 'Export',
                icon: 'pi pi-upload',
                command: () => this.openExportAccounts()
            });
        }

        items.push({
            label: 'Settings',
            icon: 'pi pi-cog',
            command: () => this.openAccountSettings()
        });

        let viewMenu;

        if (view === 'dashboard') {
            this.deselectStages();
            viewMenu = {
                label: 'Dashboard',
                icon: 'pi pi-chart-bar',
                items
            };
            this.selectedView = 'dashboard';
        } else if (view === 'list') {
            this.selectedStep = i + 1;
            this.selectedStageId = null;
            viewMenu = {
                label: 'Action',
                icon: '',
                items
            };
            this.selectedView = 'list';
        }

        this.menuItems.push(viewMenu);

        // this.menuItems.push({
        //     label: 'Settings',
        //     icon: 'pi pi-cog',
        //     command: () => this.openAccountSettings()
        // });

        this.menuItems.push({
            label: '',
            icon: 'pi pi-refresh',
            command: () => {
                this.refreshListing();
            }
        });
    }

    // Open Create Account Modal
    openAddAccount(): void {
        this.displayAddView = true;
        this.isAdd = true;
        this.isEdit = true;
    }

    //open copy Account Modal
    openAddAccountForCopy(): void {
        this.displayAddView = true;
        this.isAdd = false;
        this.isEdit = true;
        this.isCopyAccount = true;
    }

    // Fired whenever create account modal is closed
    closeModal(): void {
        this.displayAddView = false;
        this.displayEditViewDialog = false;
        this.displayView = true;
        this.isCopyAccount = false;
        this.selectedAccountId = 0;
    }

    openImportAccounts(): void {
        this.displayImport = true;
        this.objectId = 2;
    }

    callListingAfterAdd() {
        this.getAccountsList();
    }

    hideImport() {
        this.displayImport = false;
    }

    openExportAccounts(): void {
        this.accountObjId = this.app.preLoadedObjects.find(el => el.name == 'Account')?.id;
        this.allListColumns = this.columnSettingsN.listViewSections;
        this.displayExport = true;
    }

    onExportCompleted(): void {
        this.displayExport = false;
        this.allListColumns = [];
    }

    openAccountSettings(): void {
        this.displaySettings = true;
        this.displayColumnSettings = true;
    }

    refreshListing(): void {
        this.getChannelStage();
        this.getAccountsList(this.pageNumber, this.pageSize);
    }

    // Set values when deselect any stage
    deselectStages(): void {
        this.selectedStep = null;
        this.selectedStageId = null;
        this.selectedAccount = null;
    }

    settingCancelClicked() {
        this.displaySettings = false;
    }

    // Get All Accounts Listing
    getAccountsList(currentPageNumber: number = 1, currentPageSize: number = 15, resetSorting: boolean = false, lastUpdatedId?: number): void {
        if (!this.selectedChannelN) {
            return;
        }

        let pageNumber = currentPageNumber ? currentPageNumber : 1;
        this.pageNumber = pageNumber;
        this.pageSize = currentPageSize;

        const options: any = {};
        // Apply Sorting
        if (this.gridState && this.gridState['sort']) {
            options.sort = {
                SortBy: resetSorting ? null : this.gridState['sort'].field,
                IsAscending: this.gridState['sort'].order === 1 ? true : false
            }
        }

        options.isActive = this.isActive;
        options.moduleSearchValue = this.searchValue.trim() || '';
        this.sortByColumnName = options?.sort?.SortBy || null;
        this.isSortByDescending = !options?.sort?.IsAscending;

        const selectableColumns: any[] = [];
        this.selectedColumn = [];

        if (this.savedListColsVM.length > 0) {
            this.savedListColsVM.forEach((obj) => {
                if (obj.enabled) {
                    selectableColumns.push(
                        {
                            columnName: obj.columnName,
                            isCustom: obj.isCustom,
                        }
                    )
                }
            });
            const extraProperties = [
                {
                    columnName: 'NoOfUnreadLogs',
                    isCustom: false
                },
                {
                    columnName: 'stageId',
                    isCustom: false
                },
                {
                    columnName: 'leadId',
                    isCustom: false
                },
                {
                    columnName: 'NoOfTask',
                    isCustom: false
                },
                {
                    columnName: 'ReminderCount',
                    isCustom: false
                },
				{
                    columnName: 'NoOfAttachment',
                    isCustom: false
                },
                {
                    columnName: 'channelId',
                    isCustom: false
                }
            ];
            selectableColumns.push(...extraProperties);
            this.selectedColumn = selectableColumns;
        }

        // From Global Search
        if (!this.fromGlobalSearch && !this.globalSearchRefresh) {
            this.route.queryParams.subscribe((params) => {
                if (params && params.id && params.module && params.channelId && params.statusId) {
                    this.fromGlobalSearch = params.globalSearch;
                    this.globalSearchData = [];
                    this.globalSearchData.push({ 'id': params.id, 'name': params.data });
                    this.pageSize = 1;
                    this.pageNumber = 1;
                    this.selectedAccount = {
                        id: params.id,
                        statusId: parseInt(params.statusId),
                    };
                    this.isActive = this.selectedAccount?.statusId === 1;
                    const selectedChannel = this.channelsN?.filter(a => a.id == params.channelId)[0];
                    this.selectedChannelN = selectedChannel;
                    this.getChannelStage();
                    this.getColumnSettings();
                    this.app.objectId = params.id;
                    this.app.objectType = "Account";
                    this.getAccountDetailsById(this.selectedAccount.id, 'globalSearch');
                } else {
                    this.fromGlobalSearch = false;
                }
            });
        }

        const sortByColumn = this.savedListColsVM.find(fld=> fld.columnName==options?.sort?.SortBy);
        const defaultSortColumn = !this.accountTreeViewEnabled ? 'accountIdForSorting' : null;
        const sortByColumnDataType = !this.accountTreeViewEnabled ? 'Number' : null;

        if(defaultSortColumn){
            selectableColumns.push({
                columnName: 'accountIdForSorting',
                isCustom: false
            })
        }

        const mainCustomerField = this.savedListColsVM.find(fld=> fld.columnName=='mainCustomer');
        if(mainCustomerField){
            selectableColumns.push({
                columnName: 'parentAccountSequenceNumber',
                isCustom: false
            })
        }

        const requestModel: GelAllAccountRequestModel = {
            channelId: this.selectedChannelN?.id,
            stageId: this.selectedStageId,
            isActive: this.isActive,
            globalSearchValue: this.searchValue.trim() || '',
            selectableColumns: selectableColumns,
            filter: this.selectedRecent?.code,
            pageSize: currentPageSize,
            pageNumber: currentPageNumber,
            sortByColumn: options?.sort?.SortBy || defaultSortColumn,
            sortByColumnDataType: sortByColumn?.fieldDataType||sortByColumnDataType,
            isSortByDescending: !options?.sort?.IsAscending,
            filterInColumns: this.filterInColumns,
            includeChildAccounts: (this.searchValue.trim()?.length > 0 || this.filterInColumns?.length > 0 || !this.accountTreeViewEnabled)
        }

        if (this.filterInColumns && this.filterInColumns.length > 0 && requestModel) {
            this.filterInColumns.forEach((obj) => {
                let notInSelectableColumn = requestModel?.selectableColumns.find((item)=>{
                    return item?.columnName == obj?.name;
                });
                let customFieldNotinSelectableColumn = this.savedListColsVM.find((item)=>{
                    return item?.columnName == obj?.name;
                });
                if(!notInSelectableColumn && customFieldNotinSelectableColumn){
                    requestModel?.selectableColumns.push(
                        {
                            columnName: customFieldNotinSelectableColumn?.columnName,
                            isCustom: customFieldNotinSelectableColumn?.isCustom || false
                        }
                    );
                }
            });
        }
        const groupRequest: GetAllAccountsGroupByRequest = {
            ...requestModel,
            includeChildAccounts: true,
            groupByColumnName: this.selectedGroupByValue?.groupByColumnName,
            isGroupByColumnCSV: this.selectedGroupByValue?.isGroupByColumnCSV,
            pageSize: 15,
            pageNumber: 1,
            rootPageSize: currentPageSize,
            rootPageNumber: currentPageNumber,
            rootSortByColumnName: this.selectedGroupByValue?.groupByColumnName,
            isRootSortByDescending: (this.selectedGroupByValue?.fieldDataType=="DateTime") as boolean,
            timezone: (this.selectedGroupByValue?.isDateWithTime) ? this.timeZoneService.getUserTimezoneName() : null
        }
        const checkGroupColumn = groupRequest?.selectableColumns.find(field => field.columnName == this.selectedGroupByValue?.groupByColumnName);
        if (this.selectedGroupByValue && !checkGroupColumn) {
            groupRequest?.selectableColumns.push({
                columnName: this.selectedGroupByValue?.groupByColumnName,
                isCustom: this.selectedGroupByValue?.isCustom
            })
        }

        const accountApiCall = this.selectedGroupByValue ? this.accountServiceN.getAccountsGroupList(groupRequest) : this.accountServiceN.getAccountsListWithFilters(requestModel);

        this.appMainService.isShowSpinner('getAccountList');
        accountApiCall.pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response) => {
                    if (response) {
                        this.accountList = this.selectedGroupByValue ? response.groupedList || [] : response?.list || [];
                        this.totalRecords = response?.totalNumberOfRows;
                        this.updateRowGroupMetaData();
                        if (lastUpdatedId) {
                            this.selectedAccount = this.rowGroupMetadata.find(data => data?.id == lastUpdatedId)||this.selectedAccount;
                        }
                        this.noAccountFindOrLoadingText = this.rowGroupMetadata.length ? '' : 'No accounts found.';
                        this.getPageListCalling = true;
                        this.appMainService.isHideSpinner('getAccountList');
                        this.isFirst = false;
                        this.showFloatHeader = true;
                        // From Global Search
                        if (this.fromGlobalSearch) {
                            this.selectedView = 'split';
                            this.savedListCols = JSON.parse(JSON.stringify(this.accountListCols));
                            this.onRowSelect({ data: { id: this.selectedAccount.id } });
                        }
                    }
                },
                error: (error) => {
                    this.isFirst = false;
                    this.noAccountFindOrLoadingText = 'No accounts found.';
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error!',
                        detail: 'Error occurring when loading accounts. Please try after sometime.'
                    });
                    this.appMainService.isHideSpinner('getAccountList');
                },
                complete: () => {

                }
            })
    }

    saveFilterDataChannalWise(selectedColumns: SavedFilterData){
        this.appMainService.isShowSpinner('saveFilterDataChannalWise');
        let requestBody: {
          moduleId: number,
          channelId: number,
          filterData: SavedFilterData
        } = {
          moduleId: AccountModuleId,
          channelId: this.selectedChannelN?.id,
          filterData: selectedColumns,
        }

        this.accountServiceN.saveFilterDataChannalWise(requestBody).subscribe({
          next: (response)=>{
            this.appMainService.isHideSpinner('saveFilterDataChannalWise');
          },
          error: (error)=>{
            this.messageService.add({
                severity: 'error',
                summary: 'Error!',
                detail: 'Error occurring when saving filter data. Please try after sometime.'
            });
            this.appMainService.isHideSpinner('saveFilterDataChannalWise');
          }
        });
      }


    resetSavedFilterChannelWise() {
        this.appMainService.isShowSpinner('resetSavedFilterChannelWise');
        let requestBody: {
            moduleId: number,
            channelId: number,
        } = {
            moduleId: AccountModuleId,
            channelId: this.selectedChannelN?.id,
        }
        this.accountServiceN.resetSavedFilterChannelWise(requestBody).subscribe({
            next: (response) => {
                this.appMainService.isHideSpinner('resetSavedFilterChannelWise');
            },
            error: (error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error!',
                    detail: 'Error occurring when reset filter data. Please try after sometime.'
                });
                this.appMainService.isHideSpinner('resetSavedFilterChannelWise');
            }
        });
    }

    resetSavedGroupByChannelWise() {
        this.appMainService.isShowSpinner('resetSavedGroupByChannelWise');
        let requestBody: {
            moduleId: number,
            channelId: number,
        } = {
            moduleId: AccountModuleId,
            channelId: this.selectedChannelN?.id,
        }
        this.accountServiceN.resetSavedGroupByChannelWise(requestBody).subscribe({
            next: (response) => {
                this.appMainService.isHideSpinner('resetSavedGroupByChannelWise');
            },
            error: (error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error!',
                    detail: 'Error occurring when reset filter data. Please try after sometime.'
                });
                this.appMainService.isHideSpinner('resetSavedGroupByChannelWise');
            }
        });
    }

    getFilterData() {
        this.appMainService.isShowSpinner('getFilterData');
        let requestModel: { moduleId: number, channelId: number } = {
            moduleId: AccountModuleId,
            channelId: this.selectedChannelN?.id,
        }
        this.accountServiceN.getSavedFilterDataChannalWise(requestModel).subscribe({
            next: (data: SavedFilterData) => {
                if(data){
                    this.saveFilterData = data;
                    this.filterInColumns = this.saveFilterData?.filter.map((data)=>{
                        let field: FilterInColumn = {
                            name: data.columnName,
                            operator: data?.operator,
                            operationType: data?.operationType,
                            isCustom: data?.isCustom,
                            fieldId: data?.fieldId,
                        }
                        if (data.operator == "On" || data.operator == "NotOn") {
                            field.values = [];
                            field = this.dateOnOperatorListValue(data, field);
                        } else {
                            field.values = data?.values;
                        }
                        return field;
                    });
                    if(this.savedListCols?.length > 0){
                        this.enabledListCols = this.savedListCols.filter(field => field.enabled && ![FormControlList.Decimal, FormControlList.Currency, FormControlList.Percentage, FormControlList.Number, FormControlList.Picture , FormControlList.FileUpload].includes(field.formControlType));

                        this.enabledListCols.map(field => {
                            field.groupByColumnName = (field.columnName == 'tags') ? 'tagsCsv' : field.columnName;
                            field.isGroupByColumnCSV = [FormControlList.MultipleDropDownList, FormControlList.CheckBox].includes(field.formControlType);
                        });
                        this.selectedGroupBy = this.enabledListCols.find((item)=>{
                            return item?.id == this.saveFilterData?.groupByFieldId;
                        });
                    }
                    this.selectedGroupByValue = this.selectedGroupBy;
                    if (this.selectedGroupBy) {
                        this.disabledLabelNames = [...new Set([...this.appliedFilterColName, this.selectedGroupBy.columnName])];
                    }else{
                        this.disabledLabelNames = [];
                    }
                }else{
                    this.saveFilterData = null;
                    this.filterInColumns = null;
                    this.selectedGroupByValue = null;
                    this.selectedGroupBy = null;
                    this.disabledLabelNames = [];
                }

                if (this.selectedView == 'split') {
                    this.getAccountsList(this.pageNumber ? this.pageNumber : 1, this.pageSize ? this.pageSize : 15, true);
                }
                else {
                    this.getAccountsList(this.pageNumber ? this.pageNumber : 1, this.pageSize ? this.pageSize : 15, true);
                }
                this.appMainService.isHideSpinner('getFilterData');
            },
            error: (error)=>{
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error!',
                    detail: 'Error occurring when getting filter data. Please try after sometime.'
                });
                this.appMainService.isHideSpinner('getFilterData');
              },
        })
    }

    public dateOnOperatorListValue(data: {
        columnName?: string;
        value?: string;
        operator: string;
        operationType?: string;
        values?: string[];
        isCustom?: boolean;
        fieldId?: number;
    }, field: FilterInColumn) {

        const dateRange = filterDateRangeHelper(data?.values[0]);
        let dateRangeFrom: Date|null = dateRange?.dateRangeFrom;
        let dateRangeTo: Date|null = dateRange.dateRangeTo;

        if((dateRangeFrom && dateRangeTo)){
            const fieldDetails = this.savedListColsVM.find(fld=> fld?.columnName==data?.columnName);
            field.operator = data.operator=='NotOn' ? 'NotBetween' : 'Between';
            dateRangeFrom = this.timeZoneService._getUTCDateTimeWithZone(dateRangeFrom, (fieldDetails?.isDateWithTime||false), true, !['This Month','Last Month'].includes(data?.values[0]));
            dateRangeTo = this.timeZoneService._getUTCDateTimeWithZone(dateRangeTo, (fieldDetails?.isDateWithTime||false), true, !['This Month','Last Month'].includes(data?.values[0]));
            dateRangeTo.setDate(dateRangeTo.getDate() + 1);
            dateRangeTo = new Date(dateRangeTo.getTime() - 1000);
            field.values.push(this.timeZoneService._getUTCDateTimeString(dateRangeFrom),this.timeZoneService._getUTCDateTimeString(dateRangeTo));
        }else if(data.values?.[0]){
            field.operator = data.operator=='NotOn' ? 'NotBetween' : 'Between';
            field.values.push(data.values?.[0],data.values?.[0])
        }

        return field;
    }

    // Fired when there is any change on Table
    async getAllAccountsWithPagination(event?: LazyLoadEvent): Promise<void> {
        if (event) {
            this.pageSize = event.rows;
            this.pageNumber = (event.first / event.rows) + 1;

            this.onRowUnselect();

            if (event.sortField) {
                const temp = {
                    field: event.sortField,
                    order: event.sortOrder
                };

                this.gridState['sort'] = temp;
            }

            if (event.filters) {
                this.onFilterChange(event);
            }
        }
        else {
            this.pageSize = 15;
            this.pageNumber = 1;
        }


        if (this.selectedChannelN && this.getPageListCalling) {
            this.selectedView = 'list';
            this.getAccountsList(this.pageNumber, this.pageSize, false);
        }
    }

    onFilterChange(event): void {
        const filters = [];
        let userId = 0;

        if (this.selectedRecent.code == 'MyAccounts') {
            userId = this.app.user.userId;
        }

        for (const filterName in event.filters) {
            filters.push({
                field: filterName,
                value: event.filters[filterName].value,
                matchMode: event.filters[filterName].matchMode
            });
        }

        this.gridState['filters'] = filters;
    }

    refreshList() {
        this.isMenuShow = true;
        this.fromGlobalSearch = false;
        this.globalSearchRefresh = true;
        this.savedListCols = this.accountHelper.getSectionWiseFlatCols(this.columnSettingsN?.listViewSections);
        this.pageNumber = 1;
        this.pageSize = 15;
        this.getAccountsList();
    }

    // Fired when account add is completed
    completeAccountAdd(response: { accountDetails: any, type: 'save' | 'view' }): void {
        this.displayAddView = false;

        if (response.type == 'view' && response?.accountDetails?.referenceId) {
            this.showEditAccount(response?.accountDetails?.referenceId, true)
        }

        if (this.isCopyAccount && this.channelObjForCopy && this.selectedChannelN?.id != this.channelObjForCopy?.id) {
            this.selectedChannelN = this.channelObjForCopy;
            this.changeChannel();
            this.isCopyAccount = false;
            return;
        }
        this.getAccountsList(1, this.pageSize,false,response?.accountDetails?.referenceId);
        this.toggleIsFirst();
    }

    completeAccountEdit(accountId: number) {
        this.displayAddView = false;

        if (this.selectedView == 'split') {
            this.getAccountDetailsById(accountId);
            this.app.getAllObjects(false);
        }

        this.getAccountsList();
        this.first = 0;
        this.isFirst = true;
        this.isEdit = false;
    }

    updateRowGroupMetaData(): void {
        this.rowGroupMetadata = [];
        if (!this.selectedGroupByValue) {
            this.getExpandedRows(this.accountList, 'main');
        } else if (this.accountList?.length > 0) {
            this.accountList.map((accountGroup, index) => {
                accountGroup.id = index+1;
                this.expandedRows[accountGroup.id] = false;
                accountGroup.list?.length > 0 && this.getExpandedRows(accountGroup.list, 'main');
            })
        }
        this.rowGroupMetadata = this.accountList;
    }

    getExpandedRows(list, main?): void {
        list.forEach(element => {
            element.viewDetails = main == 'main' ? true : false;
            if (element.hasChildAccounts) {
                this.expandedRows[element.id] = false;
            }
        });

        this.setEmptyAccountColor(list);
    }

    setAccountRowColor(accountList: any[], parentAccountId: number, rowColor: string){
        const childAccounts = accountList.filter(account=> account.parentAccountId==parentAccountId);
        if(childAccounts?.length>0){
            childAccounts.map(account=>{
                account.rowColor = rowColor;
                this.setAccountRowColor(accountList, account.id, rowColor);
            });
        }
    }

    findParentAccountInCurrentPage(accountList: any[], parentId: number, accountDetails: any): any | null {
        if(!parentId) return accountDetails;
        const parentAccount = accountList.find(account=> account.id==parentId);
        if(parentAccount){
            return this.findParentAccountInCurrentPage(accountList,parentAccount?.parentAccountId, parentAccount);
        }
        return accountDetails;
    }

    setEmptyAccountColor(accountList: any[]){
        accountList.map(account=>{
            const findIndex = accountList.findIndex(accountDetails=> accountDetails.id==account.id);
            if(findIndex>=0 && !account?.rowColor){
                const preAdjacents = accountList.slice(0, findIndex).reverse();
                const postAdjacents = accountList.slice(findIndex, (accountList.length-1));

                let rowColorAccount = preAdjacents.find(account=> account?.rowColor);

                if(!rowColorAccount){
                    rowColorAccount = postAdjacents.find(account=> account?.rowColor);
                }

                if(rowColorAccount?.parentAccountId && (rowColorAccount?.parentAccountId==account?.parentAccountId)){
                    account.rowColor = rowColorAccount?.rowColor;
                }else{
                    account.rowColor = rowColorAccount?.rowColor=='child-color1' ? 'child-color2' : 'child-color1';
                }

                if(account?.parentAccountId){
                    const parentAccount = this.findParentAccountInCurrentPage(accountList, account?.parentAccountId, account);
                    parentAccount.rowColor = account?.rowColor;
                    this.setAccountRowColor(accountList, parentAccount.id, account?.rowColor);
                }else{
                    this.setAccountRowColor(accountList, account.id, account?.rowColor);
                }

            }
        });
    }

    // Load Listing from Start
    loadListingWithFilters(): void {
        this.first = 0;
        this.isFirst = true;

        if (this.selectedView == 'list') {
            this.getChannelStage();
            this.getAccountsList();
        } else {
            this.closeSplitView();
        }
    }

    // Set Selected View
    setSelectedView(event): void {
        this.selectedView = event;
    }

    // Set List Columns for Listing
    setListColumns(): void {
        this.savedListCols = this.accountHelper.getSectionWiseFlatCols(this.columnSettingsN?.listViewSections);
    }

    // Close the split view and open listing
    closeSplitView(reloadList: boolean = true): void {
        this.selectedAccount = null;
        this.selectedView = 'list';
        this.isMenuShow = true;
        this.setListColumns();
        this.selectedTabIndex = 0;
        reloadList && this.getAccountsList(this.pageNumber, 15);

        // From global search
        if (this.fromGlobalSearch || this.globalSearchRefresh) {
            this.pageSize = 15;
            this.fromGlobalSearch = false;
            this.router.navigate(["accounts"]);
        }
    }
    hideMenu(type: 'menu'|'table'){
        switch(type){
            case 'menu':
                this.isMenuShow = false;
                break;
            case 'table':
                this.isLeftTableHide = true;
                break;
        }
    }
    showMenu(type: 'menu'|'table'){
        switch(type){
            case 'menu':
                this.isMenuShow = true;
                break;
            case 'table':
                this.isLeftTableHide = false;
                break;
        }
    }

    // Change channel stage
    filterAccountsByStage(index: number, stage: StageN): void {
        if (this.selectedView == 'kanban' || this.selectedView == 'dashboard') {
            this.selectedView = 'list';
            this.buildMenuBar(this.selectedView, index);
        }
        this.selectedStep = index + 1;
        this.selectedStage = stage;
        this.selectedStageId = stage.id;
        this.loadListingWithFilters();
    }

    // Select a row from the Listing Table
    onRowSelect($event: any, selfClick = false): void {
        if ($event.data) {
            this.hasChildAccounts = $event.data?.hasChildAccounts;
            this.selectedAccount = $event.data;
            this.selectedAccount.hasChildAccounts = $event.data?.hasChildAccounts;
            if (!selfClick) {
                this.app.allActivityLogs = [];
            }
            this.selectedTabIndex = this.accountViewTabIndex.OVERVIEW;
            this.filteredAccount = null;
            this.savedListCols = JSON.parse(JSON.stringify(this.accountListCols));
            this.selectedView = 'split';
            this.isMenuShow = false;
            this.app.objectId = $event.data.id;
            this.app.objectType = "Account";
            this.selectedAccountFromTable = $event.data.id;
            this.filteredAccount = this.selectedAccount;
            this.displayAccountDetails = false;

            if (!this.app.allObjects || !this.app.allObjects.length) {
                let object = this.app.preLoadedObjects.map(elem => {
                    return { name: elem.name, id: this.objectId, type: elem.id }
                });
                this.app.allObjects = object;
            }

            this.objectTypeId = this.app.allObjects?.length ? this.app.allObjects
                .filter(el => el.name === this.app.objectType)[0]?.type : 0;

        }

    }

    // Unselect a row from the Listing Table
    onRowUnselect() {
        this.isMenuShow = true;
        this.selectedAccount = null;
        this.savedListCols = this.listColsAll;
        this.selectedView = 'list';
    }

    // Get Contact List from Store
    getContactListByStore(): void {
        this.storeService.getContactList()
            .subscribe(contactList => {
                this.contactList = contactList;
                this.contactListAttn = contactList;
            });
    }

    // Get Account Details from Store
    getAccountDetailsByStore(): void {
        this.storeService.getAccountData()
            .subscribe(accountData => {
                this.accountData = ParseHelper.DeepCopy(accountData);
            })
    }

    getAccountDetailsAfterEdit(id): void {
        this.getAccountDetailsById(id);
    }

    // Get Account Details from API
    async getAccountDetailsById(id, from: 'globalSearch' | null = null): Promise<void> {
        this.hasChildAccounts = this.selectedAccount?.hasChildAccounts;
        this.appMainService.isShowSpinner('getAccountDetailsById');
        this.accountsHttpService.getAccountDetails(id)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(resp => {
                this.selectedAccount = resp;
                if (from == 'globalSearch') {
                    this.isActive = (this.selectedAccount?.statusId == Status.Active);
                }
                this.setSelectedAccountDetails(resp, this.selectedActiveStages);
                this.storeService.setAccountData(this.selectedAccount);
                this.appMainService.isHideSpinner('getAccountDetailsById');
            }, () => {
                this.appMainService.isHideSpinner('getAccountDetailsById');
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error!',
                    detail: 'Error occurring when fetching accounts details. Please try after sometimes.'
                });
            });
    }

    toggleIsFirst() {
        this.isFirst = true;
        setTimeout(() => {
            this.isFirst = false;
        }, 100);
    }

    getAccountListAfterEdit(): void {
        this.getChannelStage();
        this.getAccountsList();
        this.toggleIsFirst();
    }

    // Set Details of the Selected Account
    setSelectedAccountDetails(account, stages): void {
        if (!account) {
            return;
        }
        let stage = stages?.filter(elem => elem.id === account.categoryId);
        let contactName: string = "";
        if (account.accountContacts?.length && account.accountContacts[0] && account.accountContacts[0].contact) {
            const contactDetails = account.accountContacts[0].contact;
            contactName = generateContactName(contactDetails);
        }
        const data = {
            ...account,
            contactName: contactName,
            accountStatus: account.accountStatus?.name || "",
            accountCategory: stage?.length ? stage[0].name : null,
            accountTypesNames: account.accountTypes?.length ? this.accountHelper.processAccountNames(account.accountTypes) : null,
            stageId: stage?.length ? stage[0].id : null,
            statusName: account.status ? account.status.name : null
        };

        let responseData: any = this.accountHelper.processAccountDetailsData(data);
        this.filteredAccount = responseData;
        this.selectedAccount = responseData;
        this.accountContacts = this.selectedAccount.accountContacts;
        for (let el of this.accountContacts) {
            if (!el.contactName) {
                let contactName: string = "";

                if (el) {
                    const contactDetails = el;
                    contactName = generateContactName(contactDetails);
                }

                el.contactName = contactName;
            }
        }

        this.accountTempAddress = this.selectedAccount.accountAddresses;
        this.primaryContact = account.accountContact?.length ? account.accountContact.filter(el => el.isPrimaryContact)[0] : null;

        this.getAllContacts();
    }

    // Handle tab change
    handleTabChange(e) {
        var index = e.index;
        this.selectedTabIndex = index;
        if (index == this.accountViewTabIndex.OVERVIEW) {
            this.onRowSelect({ data: { id: this.selectedAccount.id, index } });
        }
    }

    // Get All Contacts Functions
    getAllContacts() {
        this.contactList = this.selectedAccount?.accountContacts || [];
        this.contactList.forEach(contactData => {
            contactData.contact.isPrimaryContact = contactData.isPrimaryContact;
            contactData.contact.childAccountAccess = contactData.childAccountAccess;
        });
        this.contactList = this.contactList.map(el => el.contact) || [];
    }

    // Close account details
    onAccountDetailClose() {
        this.displayAccountDetails = false;
    }

    // Create new contact
    onAddContact(data): void {
        this.getAccountDetailsById(this.selectedAccount.id);
    }

    postContactEdit() {
        this.getAccountDetailsById(this.selectedAccount.id);
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    getChannels(): void {
        this.appMainService.isShowSpinner('getChannel');
        this.sharedChannelService.getChannels(AccountModuleId)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
                {
                    next: (response) => {
                        const channels = response || [];
                        this.channelsN = this.permissionService.filterChannelsByPermissions(channels, ObjectNames.ACCOUNT);
                        const globalChannelId = this.permissionService.getGlobalChannelId();
                        if (typeof globalChannelId === 'number') {
                            this.selectedChannelN = this.channelsN.find(x => x?.id === globalChannelId);
                            if (!this.selectedChannelN) {
                                this.selectedChannelN = this.channelsN.find(x => x?.isDefault === true);
                                this.permissionService.setGlobalChannelId(this.selectedChannelN?.id);
                            }
                        }
                        else {
                            this.selectedChannelN = this.channelsN.find(x => x?.isDefault === true);
                            this.permissionService.setGlobalChannelId(this.selectedChannelN?.id);
                        }

                        if (this.selectedChannelN?.id) {
                            this.getColumnSettings();
                            this.getChannelStage();
                        }
                        this.appMainService.isHideSpinner('getChannel');
                    },
                    error: (error) => {
                        this.appMainService.isHideSpinner('getChannel');
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: error?.error?.message ? error?.error?.message : 'Channels are not loaded, please try again...'
                        });

                    },
                    complete: () => {
                    },
                });
    }

    getChannelStage(): void {
        this.appMainService.isShowSpinner('getStages');
        this.accountServiceN.getStages(this.selectedChannelN?.id, this.isActive, this.selectedRecent?.code)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response) => {
                    this.savedStepbarN = true;
                    this.stagesCountN = response || [];
                    this.appMainService.isHideSpinner('getStages');
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('getStages');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error?.error?.message ? error?.error?.Message : 'Stages are not loaded, please try again...'
                    });

                }
            });
    }

    changeChannel(): void {
        const isChangePermission: boolean | string = this.permissionService.changeUserPermissionByChannel(this.selectedChannelN?.id);
        if (isChangePermission === 'newPermission') {
            this.confirmationService.confirm({
                message: 'New channel permission has been added, you need to logout and then Login again',
                header: 'Error',
                icon: 'pi pi-info-circle',
                accept: () => {
                    this.userService.logout();
                    return;
                },
                acceptLabel: 'Log Out',
                reject: () => {
                }
            });
        }
        if (isChangePermission === true) {
            this.permissionService.setGlobalChannelId(this.selectedChannelN?.id);
            this.setPermissions();
        }

        this.selectedView = 'list';
        this.first = 0;
        this.pageNumber = 1;
        this.toggleIsFirst();
        this.getChannelStage();
        this.getColumnSettings(true);
        if (this.fromGlobalSearch || this.globalSearchRefresh) {
            this.pageSize = 15;
            this.fromGlobalSearch = false;
            this.router.navigate(["accounts"]);
        }
    }

    getColumnSettings(fromUpdateSettings = false): void {
        this.appMainService.isShowSpinner('getColumnSettings');
        this.sharedColumnSettingsService.getColumnSettings(AccountModuleId, this.selectedChannelN?.id)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
                {
                    next: (response) => {
                        this.columnSettingsN = response || [];
                        this.appMainService.isHideSpinner('getColumnSettings');
                        this.processColumnSettings(this.columnSettingsN, fromUpdateSettings);
                        this.getFilterData();

                        //dummy action column
                        // this.showActionColumn && this.columnSettingsN.listViewSections[0].fields.unshift({
                        //     id:555,
                        //     enabled:true,
                        //     displayOrder:1,
                        //     isCustom:false,
                        //     dragable:true,
                        //     columnName:"Action",
                        //     fieldDataType:"",
                        //     formControlType:"",
                        //     childFields:[],
                        //     groupByColumnName:"",
                        //     isDateWithTime:false,
                        //     isGroupByColumnCSV:false,
                        //     isRequired:true,
                        //     mapObject:"account",
                        //     name:"Action",
                        // })
                    },
                    error: (error) => {
                        this.appMainService.isHideSpinner('getColumnSettings');
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: error?.error?.message ? error?.error?.Message : 'Column Settings are not loaded, please try again...'
                        });
                    },
                    complete: () => {

                    },
                });
    }

    setUpdatedAccountListCols() {
        let matchedCol = this.savedListCols.filter(col => col.columnName === this.accountListCols[0].columnName);
        if (matchedCol.length) {
            this.accountListCols = JSON.parse(JSON.stringify(matchedCol));
        }
    }

    processColumnSettings(columnSettings: Partial<ColumnSettingsN>, fromUpdateSettings = false): void {
        this.savedStepbarN = columnSettings?.displayStepBar;
        this.savedDefaultView = columnSettings?.defaultViewType == 1 ? 'list' : 'split';

        if (columnSettings?.listViewSections) {
            this.savedListCols = this.accountHelper.getSectionWiseFlatCols(columnSettings?.listViewSections);
            this.savedListColsVM = JSON.parse(JSON.stringify(this.savedListCols));
            this.setGroupCols();
        }

        if (columnSettings?.detailsViewSections) {
            this.savedDetailViewCols = this.accountHelper.getSectionWiseFlatCols(columnSettings?.detailsViewSections);
        }
        this.setUpdatedAccountListCols()
        this.listColsAll = JSON.parse(JSON.stringify(this.savedListCols));
        if (!fromUpdateSettings) {
            this.selectedView = this.savedDefaultView;
            this.buildMenuBar(this.selectedView, 0);
        } else {
            this.savedListCols = this.selectedView == 'split' ? JSON.parse(JSON.stringify(this.accountListCols)) : this.listColsAll;
            this.fromUpdateSettings = true;
            this.gridState['filters'] = [];
            this.gridState['sort'] = null;
        };
    }

    savedColumnSettings(): void {
        this.displayColumnSettings = false;
        this.fromUpdateSettings = false;
        this.getColumnSettings(true);
    }

    cancelColumnSettings(): void {
        this.displayColumnSettings = false;
        this.fromUpdateSettings = false;
    }

    setGroupCols() {
        this.enabledListCols = this.savedListCols.filter(field => field.enabled && ![FormControlList.Decimal, FormControlList.Number, FormControlList.Picture, FormControlList.FileUpload].includes(field.formControlType));
        this.enabledListCols.map(field => {
            field.groupByColumnName = (field.columnName == 'tags') ? 'tagsCsv' : field.columnName;
            field.isGroupByColumnCSV = [FormControlList.MultipleDropDownList, FormControlList.CheckBox].includes(field.formControlType);
        });

        const checkExist = this.enabledListCols.find(field => field.columnName == this.selectedGroupByValue?.columnName);
        if (this.selectedGroupByValue && !checkExist) {
            this.selectedGroupByValue = null;
        }
    }

    showGroupBy() {
        this.selectedGroupBy = this.selectedGroupByValue || null;
    }

    applyGroup() {
        if (this.selectedGroupBy) {
            this.disabledLabelNames = [...new Set([...this.appliedFilterColName, this.selectedGroupBy.columnName])];
        }

        this.selectedGroupByValue = this.selectedGroupBy;
        this.rowGroupMetadata = [];
        let saveFilterData: SavedFilterData = {};
        saveFilterData = {
            groupByFieldId: this.selectedGroupByValue?.id ? this.selectedGroupByValue?.id : null,
            filter: this.filterInColumns?.length > 0 ? this.filterInColumns : null,
        }
        this.saveFilterDataChannalWise(saveFilterData);
        this.loadListingWithFilters();
    }

    resetGroup(reloadList: boolean = false) {
        this.disabledLabelNames = this.disabledLabelNames.filter(dln => dln !== (this.selectedGroupByValue?.columnName ?? ''));
        this.disabledLabelNames = [...new Set([...this.disabledLabelNames, ...this.appliedFilterColName])];

        this.selectedGroupBy = null;
        this.selectedGroupByValue = null;
        this.resetSavedGroupByChannelWise();
        if(reloadList){
            this.rowGroupMetadata = [];
            this.loadListingWithFilters();
        }
    }

    resetFilters(reloadList: boolean = false){
        this.applyFilters({selectedFilter: null,selectedColumnsForSaveFilterFieldsChannelWise: null}, reloadList);
    }

    applyFilters(event: { selectedFilter: FilterInColumn[], selectedColumnsForSaveFilterFieldsChannelWise: FilterInColumn[]}, reloadList: boolean = true) {
        this.filterInColumns = event?.selectedFilter||null;

        if(event?.selectedFilter?.length > 0){
            let saveFilterData: SavedFilterData = {};
            saveFilterData = {
                groupByFieldId: this.selectedGroupByValue?.id ? this.selectedGroupByValue?.id : null,
                filter: event?.selectedColumnsForSaveFilterFieldsChannelWise?.length > 0 ? event?.selectedColumnsForSaveFilterFieldsChannelWise : null,
            }
            this.saveFilterDataChannalWise(saveFilterData);
        }else{
            this.resetSavedFilterChannelWise();
        }
        if (reloadList) {
            this.first = 0;
            this.isFirst = true;
            this.getAccountsList();
        }
    }

    //#region ***Mass Edit***
    openMassEdit(){
        this.displayMassEdit = true;
    }
    closeMassEdit(){
        this.displayMassEdit = false;
    }
    //#endregion

    showFloathead(){
        this.showFloatHeader = true;
    }
    hideFloathead(){
        this.showFloatHeader = false;
    }
    changeFloathead(){
        this.showFloatHeader = false;
        setTimeout(() => {
        this.showFloatHeader = true;
        }, 300);
    }

    changeSideHeader(isShow){
        this.isShowSideBtn = isShow;
        this.changeFloathead();
    }

    loadSubModuleWidgets() {
        const newSubModules = this.moduleWidgetService.getSystemSubModules('Account') || [];
        // If user is on a submodule and it gets deleted, redirect to accounts
        if (this.selectedSubModule && 
            !newSubModules.find(m => m.id === this.selectedSubModule?.id)) {
            this.navigateToAccount();
        }
        this.subModuleWidgets = newSubModules;
    }

    navigateToSubModule(subModuleWidget: DynamicTableChildWidgetM) {
        this.showSharedContacts = false;
        this.selectedSubModule = subModuleWidget;
        this.showSubModuleWidgets = true;
        this.activeNavigation.module = false;
        this.activeNavigation.subModuleId = subModuleWidget.id;
        this.activeNavigation.contacts = false;
    }
}
